import CupsListFilters from './CupsListFilters';

export default CupsListFilters;
